module.exports = __webpack_public_path__ + "img/suncode.8df8790f.jpg";